// extracted by mini-css-extract-plugin
module.exports = {"container":"DhBX259q","title":"HmnwBvyu","eventsWrapper":"YrB4VgEy","tableContentWrapper":"vZh12DLY"};